import { ref, push, getDatabase } from 'firebase/database';
import { firebaseConfig } from './firebaseConfig';
import { initializeApp } from "firebase/app";

// Inicialización de Firebase (fuera del componente)
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

export const createNewRequirement = async (payload) => {
  const requirementsRef = ref(db, 'Requirements');
  await push(requirementsRef, payload);
};

export const buildRequirementPayload = (formData, companyRef) => ({
  nombre: formData.nombre,
  documento: formData.documento,
  direccion: formData.direccion,
  telefono: formData.telefono,
  empresa: companyRef,
  createdAt: new Date().toLocaleString('sv-SE') // ISO-like formato local
});
